const companyDetail = {
  namespaced: true,
  state() {
    return {
      companyWidgetValue: {},
      companyWidgetStatus: 'closed', // не используется
      companyChangedColumns: [] // не используется
    };
  },
  mutations: {
    set_value(state, payload) {
      state.companyWidgetValue = {...state.companyWidgetValue, ...payload};
    },
    set_status(state, payload) {
      state.companyWidgetStatus = payload;
    },
    set_changed_columns(state, payload) {
      state.companyChangedColumns = payload;
    },
  },

  actions: {
    companyWidgetSetValue({ commit }, payload) {
      commit('set_value', payload);
    },
    companyWidgetSetChangedColumns({ commit }, payload) {
      commit('set_changed_columns', payload);
    },
    companyWidgetSetStatus({ commit }, payload) {
      commit('set_status', payload);
    },
  },

  getters: {
    companyWidgetValue: (state) => state.companyWidgetValue,
    companyWidgetStatus: (state) => state.companyWidgetStatus,
    companyChangedColumns: (state) => state.companyChangedColumns,
  },
};

export default {
  ...companyDetail
}
